import { connect } from 'react-redux';
import Form from './';
import { setTextToTranscript } from '../../../../actions/dashboard-actions';

const mapDispatchToProps = {
  handleFormSubmit: (data, callback) => setTextToTranscript(data, callback),
};

export default connect(null, mapDispatchToProps)(Form);